"use client";

import { useMemo } from "react";
import clsx from "clsx";

import { useActiveHeading } from "@/hooks/useActiveHeading";
import { parseContentWithToc } from "@/utils/toc";

export default function PageCollection({
	title,
	content,
	updatedAtLabel,
}: {
	title: string;
	content: string;
	updatedAtLabel: string;
}) {
        const { parsedContent, tocItems } = useMemo(
                () =>
                        parseContentWithToc(content, {
                                emptyState: (
                                        <p className="mt-6 text-muted-foreground">
                                                Le contenu de cette page sera bientôt disponible.
                                        </p>
                                ),
                                headingClassName: "scroll-mt-32",
                        }),
                [content]
        );

        const { activeId, setActiveId } = useActiveHeading(tocItems);

	return (
		<div className="grid gap-12 lg:grid-cols-[minmax(0,1fr)_260px]">
			<article className="max-w-3xl">
				<h1>{title}</h1>
				<p className="mt-4 text-sm text-muted-foreground">
					Dernière mise à jour le {updatedAtLabel}
				</p>
				<div className="strapi-content prose mt-8 max-w-none text-base leading-relaxed">
					{parsedContent}
				</div>
			</article>
			{tocItems.length > 0 && (
				<aside className="hidden lg:block">
					<div className="sticky top-28 rounded-lg border bg-muted/30 p-6">
						<p className="text-sm font-semibold uppercase tracking-wide text-muted-foreground">
							Sommaire
						</p>
						<ul className="mt-4 space-y-1 text-sm">
							{tocItems.map((item) => (
								<li
									key={item.id}
									className={clsx(item.level === 3 && "pl-4")}
								>
									<a
										href={`#${item.id}`}
                                                                                className={clsx(
                                                                                        "block rounded-sm py-1 transition-colors",
                                                                                        activeId === item.id
                                                                                                ? "font-semibold text-foreground"
                                                                                                : "text-muted-foreground hover:text-foreground"
                                                                                )}
                                                                                onClick={() => setActiveId(item.id)}
                                                                                aria-current={
                                                                                        activeId === item.id
                                                                                                ? "true"
												: undefined
										}
									>
										{item.title}
									</a>
								</li>
							))}
						</ul>
					</div>
				</aside>
			)}
		</div>
	);
}
